import styled from 'styled-components';

const cardColors = {
  leads: {
    background: 'linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)',
    border: '#BEDBFF',
    label: '#155DFC',
    text: '#1C398E',
    main: '#2B7FFF',
  },
  converted: {
    background: 'linear-gradient(135deg, #F0FDF4 0%, #DCFCE7 100%)',
    border: '#B9F8CF',
    label: '#15C7A7',
    text: '#0D542B',
    main: '#15C7A7',
  },
  value: {
    background: 'linear-gradient(135deg, #FFF7ED 0%, #FFEDD4 100%)',
    border: '#FFD6A8',
    label: '#F54900',
    text: '#7E2A0C',
    main: '#FF6900',
  },
  rate: {
    background: 'linear-gradient(140.63deg, #ECD1FF -68.62%, #FFFFFF 100%)',
    border: '#EACCFF',
    label: '#8B5CF6',
    text: '#6E035E',
    main: '#8B5CF6',
  },
};

export const StatsCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div`
  border-radius: 16px;
  padding: 25px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${({ $type }) => cardColors[$type].background};
  border: 1px solid ${({ $type }) => cardColors[$type].border};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  perspective: 1000px;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: ${({ $type }) => cardColors[$type].main};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 10px ${({ $type }) => `${cardColors[$type].main}40`};
  transform: translateZ(0);
  backface-visibility: hidden;
`;

export const StatLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ $type }) => cardColors[$type].label};
  text-transform: uppercase;
  letter-spacing: 0.3px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ $type }) => cardColors[$type].text};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
export const IconWrapperImg = styled.img`
  transform: translateZ(0);
  backface-visibility: hidden;
  &.padd-left {
    padding-left: 3px;
  }
`;
